import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/styles';
import {
    Popover,
    CardHeader,
    Divider,
    colors,
} from '@material-ui/core';
import NotificationList from './NotificationList';
import EmptyList from './EmptyList';

const useStyles = makeStyles((theme) => ({
    root: {
        width: 350,
        maxWidth: '100%'
    },
    actions: {
        backgroundColor: colors.grey[50],
        justifyContent: 'center'
    },
    icon: {
        marginTop: 8,
        color: theme.palette.icon,
        cursor: 'pointer',
    },
    header: {
        paddingLeft: 16,
        paddingRight: 16
    },
    title: {
        fontWeight: 'bold'
    }
}));

const NotificationsPopover = props => {
    const { notifications, anchorEl, ...rest } = props;

    const classes = useStyles();

    return (
        <Popover
            {...rest}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
        >
            <div className={classes.root}>
                <CardHeader classes={{root: classes.header, title: classes.title}} title="Please note the below points while processing the application" titleTypographyProps={{variant: 'body1'}} />
                <Divider />
                {notifications.length > 0 ? (
                    <NotificationList notifications={notifications} />
                ) : (
                    <EmptyList />
                )}
            </div>
        </Popover>
    );
};

NotificationsPopover.propTypes = {
    anchorEl: PropTypes.any,
    className: PropTypes.string,
    notifications: PropTypes.array.isRequired,
};

export default NotificationsPopover;
